import styled, { keyframes, css } from 'styled-components';
import ChevronDownGray from '../../../../assets/icons/ChevronDownGray.svg';

const WrapperForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`;

const ErrorMessage = styled.p`
  color: red;
  font-size: 14px;
  margin: 0;
`;

const WrapperSection = styled.section`
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
`;

const Title = styled.h3`
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
`;

const WrapperInputs = styled.div`
  width: 100%;
  display: flex;
  gap: 8px;
  ${({ device }) => {
    if (device === 'mobile') {
      return css`
        flex-direction: column;
      `;
    }
    if (device === 'tablet') {
      return css`
        & > label {
          flex: 1 0 0;
        }
      `;
    }
    return css`
      & > label {
        flex: 1 1 calc((100% / ${({ numberColumns }) => numberColumns || 3}) - 8px);
      }
    `;
  }}
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

const CollapsibleInputs = styled.div`
  width: 100%;
  display: ${({ active }) => (active ? 'flex' : 'none')};
  flex-direction: ${({ device }) => (device === 'mobile' ? 'column' : 'row')};
  flex-wrap: ${({ device }) => (device === 'mobile' ? 'nowrap' : 'wrap')};
  gap: 8px;
  margin-top: ${({ marginTop }) => marginTop || '4px'};
  animation: ${({ active }) => (active ? fadeIn : fadeOut)} 0.2s ease-out;
`;

const WrapperSubTypesInputs = styled.div`
  width: 100%;
  display: ${({ active }) => (active ? 'grid' : 'none')};
  grid-template-columns: ${({ device }) => (device === 'mobile' ? 'repeat(1, 1fr)' : 'repeat(4, 1fr)')};
  gap: 8px;
  margin-top: ${({ marginTop }) => marginTop || '4px'};
  animation: ${({ active }) => (active ? fadeIn : fadeOut)} 0.2s ease-out;
`;

const ToggleButton = styled.button`
  font-size: 14px;
  font-weight: 600;
  line-height: 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 9px;
  align-self: ${({ device }) => (device === 'mobile' ? 'center' : 'flex-end')};
  margin-right: ${({ device }) => (device === 'mobile' ? '0' : '13px')};
  margin-top: ${({ device }) => (device === 'mobile' ? '12px' : '8px')};
  cursor: pointer;
  text-decoration: none;
  :hover {
    text-decoration: ${({ device }) => (device !== 'desktop' ? 'none' : 'underline')};
  }
`;

const Chevron = styled.span`
  width: 10px;
  height: 7px;
  margin-bottom: 2px;
  background-image: url(${ChevronDownGray});
  background-position: center;
  background-size: contain;
  background-repeat: no-repeat;
  position: relative;
  transform: ${({ active }) => `rotateX(${active ? '0deg' : '180deg'})`};
  transition: all 0.3s ease;
  cursor: pointer;
`;

export {
  WrapperForm,
  ErrorMessage,
  WrapperSection,
  Title,
  WrapperInputs,
  WrapperSubTypesInputs,
  CollapsibleInputs,
  ToggleButton,
  Chevron
};
